import { Injectable } from '@angular/core';
import { EsBaseTemplateService } from '../shared/es-base-template.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EsResponseModel } from '../shared/EsResponseModel';
import {
  AgentDto,
  AuthorityProfileModel,
  PersonProfileModel,
  UserProfileDtoResponseModel,
  UserProfileResponseModel,
} from '../../models/user-profile/user-profile.model';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RegistrationModel } from '../../models/user-profile/registration.model';
import { LookupDto } from '../../models/shared/LookupDto';

@Injectable()
export class UserProfileService extends EsBaseTemplateService {
  protected override BASE_API: string = environment.userProfileDomainURL;

  basePath: string = 'Profile';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public GetUserProfile(): Observable<UserProfileDtoResponseModel> {
    const url = this.buildUrl('Get');
    return this.httpClient
      .get<UserProfileDtoResponseModel>(url)
      .pipe(catchError(this.handleError));
  }

  public ValidateLicenseNumber(licenseNumber: string, licenseIssuerId: number) {
    const url = this.buildUrl(
      `ValidateAuthorityLicense?licenseNo=${licenseNumber}&licenseIssuerId=${licenseIssuerId}`
    );
    return this.httpClient.get<boolean>(url).pipe(catchError(this.handleError));
  }

  public SaveProfile(model: RegistrationModel) {
    const url = this.buildUrl(`EditProfile`);
    return this.httpClient
      .post<string>(url, model)
      .pipe(catchError(this.handleError));
  }

  public AddAgent(agent: AgentDto) {
    const url = this.buildUrl(`AddAgent`);
    return this.httpClient
      .post<number>(url, agent)
      .pipe(catchError(this.handleError));
  }

  public DeleteAgent(agentId: number) {
    let model = {
      agentId: agentId
    }
    const url = this.buildUrl(`DeleteAgent`);
    return this.httpClient
      .post<boolean>(url, model)
      .pipe(catchError(this.handleError));
  }

  public AgentExist(identityNumber: string) {
    let model = {
      IdNumber: identityNumber
    };
    const url = this.buildUrl(`AgentExist`);
    return this.httpClient
      .post<boolean>(url, model)
      .pipe(catchError(this.handleError));
  }

  public EnableAgentLogin(agentId: number) {
    let model = {
      agentId: agentId
    }; 
    const url = this.buildUrl(`EnableAgentLogin`);
    return this.httpClient
      .post<boolean>(url, model)
      .pipe(catchError(this.handleError));
  }

  public SaveAuthorityProfile(profile: AuthorityProfileModel) {
    const url = this.buildUrl(`SaveAuthorityProfile`);
    return this.httpClient
      .post<EsResponseModel<boolean>>(url, profile)
      .pipe(catchError(this.handleError));
  }

  public GetCustomerServiceCentersByAreaID(
    areaID: number
  ): Observable<LookupDto[]> {
    const url = this.buildUrl(
      `GetCustomerServiceCentersByAreaID?AreaID=${areaID}`
    );
    return this.httpClient
      .get<LookupDto[]>(url)
      .pipe(catchError(this.handleError));
  }

  public GetLicenseIssuers(emirateId: number): Observable<LookupDto[]> {
    const url = this.buildUrl(
      `GetLicenseIssuersByEmirateId?EmirateId=${emirateId}`
    );
    return this.httpClient
      .get<LookupDto[]>(url)
      .pipe(catchError(this.handleError));
  }

  public override buildUrl(endingUri: string): string {
    return `${this.BASE_API}${this.basePath}/${endingUri}`;
  }
}
